export function validCoordinates(geo) {
  if (geo?.lat === "" || geo?.lat == null || geo?.lng === "" || geo?.lng == null) {
    return false;
  }
  const lat = Number(geo.lat);
  const lng = Number(geo.lng);
  return Number.isFinite(lat) && lat >= -90 && lat <= 90
    && Number.isFinite(lng) && lng >= -180 && lng <= 180;
}
